import { useSyncExternalStore } from 'react'

/**
 * SC-473: the chat panel is mounted ONCE at app level (one Matrix client). When the dashboard's
 * Chat page is showing it registers its placeholder element here, and MatrixChatMount docks the
 * panel over it instead of showing the floating window. No slot = in-game popup behaviour.
 */
let slot: HTMLElement | null = null
const listeners = new Set<() => void>()

export function setChatPageSlot(el: HTMLElement | null): void {
  if (slot === el) return
  slot = el
  listeners.forEach((l) => l())
}

/**
 * Registers `el` as the page slot and returns its unregister. Unregistering clears the slot only
 * if `el` is still the current one, so an outgoing page can't wipe out an incoming page's slot.
 */
export function registerChatPageSlot(el: HTMLElement): () => void {
  setChatPageSlot(el)
  return () => {
    if (slot === el) setChatPageSlot(null)
  }
}

export function getChatPageSlot(): HTMLElement | null {
  return slot
}

function subscribe(l: () => void) {
  listeners.add(l)
  return () => {
    listeners.delete(l)
  }
}

export function useChatPageSlot(): HTMLElement | null {
  return useSyncExternalStore(subscribe, getChatPageSlot, () => null)
}
